<template>
  <div>
    <report-pbi
      report-id="82a1f474-01b1-408b-90a9-fd4a7a820835"
      group-id="5de7d4a7-b0d1-41a8-a978-693e831cfdcd"
      page-name="81f800ed-1b96-4732-a9ed-c95ed2ed76c5"
    ></report-pbi>
  </div>
</template>

<script>
import reportPbi from '@/components/organisms/report-pbi/index.vue';

export default {
  components: {
    reportPbi,
  },
};
</script>

<!-- Inicio Script EDNA Center LGPD -->
<!--
<script>EDNA_TOKEN = "Código-do-Cliente";</script>
<script type="text/javascript" src="https://app.edna.center/script/privacidade.js"> </script>
-->
<!-- Termino Script EDNA Center LGPD -->

<style lang="scss" scoped>
.wrapper {
  background-color: #fff;
  width: 100px;
  height: 50px;
}
</style>
